module.exports = __webpack_public_path__ + "img/Digitalocean.246b5db0.png";